import { Components, Theme } from '@mui/material';

export const buildMuiTabComponent = (): Components<Omit<Theme, 'components'>>['MuiTab'] => ({
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '10px 20px',
      minHeight: '48px',
      textTransform: 'none',
      background: theme.palette.background.default,
      '&:after': {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: '2px',
        background: theme.palette.primary['20'],
        bottom: '0',
      },
      '> svg.MuiTab-iconWrapper': {
        marginRight: '11.81px',
        marginLeft: '0px',
        fontSize: '22px',
      },
      '> p': {
        '~svg.MuiTab-iconWrapper': {
          marginLeft: '11.81px',
          marginRight: '0px',
        },
      },
    }),
  },
});
